import { Box } from "@mui/material"
import { APP_QR_CODE_LEVEL } from "app-constants/constants"
import { QRCodeSVG } from "qrcode.react"
import React from "react"
import { useElementSize } from "usehooks-ts"

interface QRCodeProps {
  value: string
  ratio?: number
  className?: string
}

const QRCode = (props: QRCodeProps) => {
  const { value, ratio = 1.685, className } = props

  const [ref, { width, height }] = useElementSize()
  const size = Math.max(width, height) / ratio

  return (
    <Box {...{ ref }} className={className}>
      <QRCodeSVG value={value} level={APP_QR_CODE_LEVEL} size={size} />
    </Box>
  )
}

export default QRCode
